function initMenu(){
    menuToggle();
    opacityHeaderOnScroll();
}

function menuToggle() {
    const menu = document.querySelector('.header-burger');
    const menuList = document.querySelector('.header-nav');
    menu.addEventListener('click', function () {
        menuList.classList.toggle('active');
    });
    let windowWidth = window.innerWidth;
    if(windowWidth < 992){
        const menuItems = document.querySelectorAll('.header-nav__item--parent');
        menuItems.forEach(item => {
            item.addEventListener('click', function () {
                item.classList.toggle('submenu-active');
            });
        });
    }
}

function opacityHeaderOnScroll() {
    const header = document.querySelector('.header-main');
    window.addEventListener('scroll', function () {

        if (window.scrollY > 117) {
            header.classList.add('opacity');
        } else {
            header.classList.remove('opacity');
        }
    });
    if(window.scrollY > 117){
        header.classList.add('opacity');
    }
}




export default {initMenu};